@if (message) {
    <div class="message message-{{ message.type }} box-border p-4 flex flex-row gap-2 at-message">
        <ca-icon [icon]="message.type | messageTypeToIcon" class="me-2 icon-{{ message.type }}"></ca-icon>
        <div class="flex flex-col w-full">
            <div class="flex justify-between align-items-start">
                <div>
                    @if (message.title) {
                        <span class="ca-bold" data-testid="message-title">{{ message.title }}</span>
                    }
                    <div [class.mt-2]="message.title">
                        <p class="mb-0 ca-text-md" data-testid="message-content" [innerHTML]="message.content | markdownIt"></p>
                        @if (message.contentList) {
                            <ul class="mb-0" data-testid="message-content-list">
                                @for (item of message.contentList; track item) {
                                    <li>
                                        {{ item }}
                                    </li>
                                }
                            </ul>
                        }
                    </div>
                </div>
                @if (message.closable) {
                    <ca-icon
                        data-testid="message-close-button"
                        icon="cross"
                        class="cursor-pointer at-close-message"
                        (click)="remove.emit(message)"
                    ></ca-icon>
                }
            </div>
            @if (message.buttonLabel) {
                <div class="flex gap-4 mt-2">
                    @if (message.routerLink || message.action) {
                        <a
                            mat-button
                            class="ca-button ca-button-no-padding mt-auto px-0 at-action-button"
                            data-testid="message-action-button"
                            (click)="message.action ? message.action() : null"
                            [disabled]="message.disabled"
                            disableRipple="true"
                            [routerLink]="message.routerLink"
                            [queryParams]="message.routerLinkQueryParams"
                        >
                            <ng-container
                                *ngTemplateOutlet="buttonContentElement; context: { $implicit: message.buttonLabel }"
                            ></ng-container>
                        </a>
                    }
                    @if (message.url) {
                        <a
                            disableRipple="true"
                            mat-button
                            class="ca-button ca-button-no-padding mt-auto px-0 at-action-button"
                            data-testid="message-action-link"
                            [disabled]="message.disabled"
                            [href]="message.url"
                        >
                            <ng-container
                                *ngTemplateOutlet="buttonContentElement; context: { $implicit: message.buttonLabel }"
                            ></ng-container>
                        </a>
                    }
                </div>
            }
            @if (message.links) {
                <div class="flex gap-4 mt-2">
                    @for (link of message.links; track link) {
                        @if (link.routerLink) {
                            <a
                                mat-button
                                disableRipple="true"
                                class="ca-button ca-button-no-padding mt-auto px-0 at-action-button"
                                data-testid="message-action-button"
                                [disabled]="link.disabled"
                                [routerLink]="link.routerLink"
                                [queryParams]="link.routerLinkQueryParams"
                            >
                                <ng-container *ngTemplateOutlet="buttonContentElement; context: { $implicit: link.label }"></ng-container>
                            </a>
                        }
                        @if (link.url) {
                            <a
                                disableRipple="true"
                                mat-button
                                class="ca-button ca-button-no-padding mt-auto px-0 at-action-button"
                                data-testid="message-action-link"
                                [disabled]="link.disabled"
                                [href]="link.url"
                            >
                                <ng-container *ngTemplateOutlet="buttonContentElement; context: { $implicit: link.label }"></ng-container>
                            </a>
                        }
                    }
                </div>
            }
        </div>
    </div>
}

<ng-template #buttonContentElement let-buttonLabel>
    <span class="button-title">{{ buttonLabel }}</span>
    <ca-icon icon="arrow-right" class="ca-icon-s"></ca-icon>
</ng-template>
